import { render, staticRenderFns } from "./MainMenuHeader.vue?vue&type=template&id=4dc71f76&scoped=true&"
import script from "./MainMenuHeader.vue?vue&type=script&lang=js&"
export * from "./MainMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuHeader.vue?vue&type=style&index=0&id=4dc71f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc71f76",
  null
  
)

export default component.exports